// Generated by Melange

import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function ClientsCardMobile(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match[0].homePage;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("img", {
        className: "sm:px-24",
        alt: "outsourcing",
        src: StaticAsset.src("/static/images/outsourcing.png")
      }),
      JsxRuntime.jsx("h4", {
        children: homePage.outsourcing_title,
        className: "h4 text-center text-error-variant mt-6"
      }),
      JsxRuntime.jsx("p", {
        children: homePage.outsourcing_text,
        className: "paragraph-large opacity-64 text-center mt-2 text-error-variant"
      }),
      JsxRuntime.jsxs(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Outsourcing */ 2
        },
        className: "text-center block paragraph cursor-pointer mt-6 link-hover text-error-variant",
        children: [
          Buhta_landing__I18n.trans(intl, "more_details"),
          JsxRuntime.jsx("img", {
            className: "inline ml-1",
            src: StaticAsset.src("/static/icons/forward-pink.svg")
          })
        ]
      })
    ],
    className: "bg-black-landing py-10 px-6 sm:px-48"
  });
}

const make = ClientsCardMobile;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
